import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, withModifiers as _withModifiers, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = {
  class: "nav nav-tabs bg-white border-0 rounded-0",
  id: "myTab",
  role: "tablist"
}
const _hoisted_4 = {
  key: 0,
  class: "nav-item",
  role: "presentation"
}
const _hoisted_5 = {
  class: "tab-content p-15 p-sm-20 p-md-25 p-lg-30",
  id: "myTabContent"
}
const _hoisted_6 = {
  class: "tab-pane fade show active",
  id: "edit-user-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12 mb-20" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "col-md-6 mb-20" }
const _hoisted_13 = { class: "col-md-6 mb-20" }
const _hoisted_14 = { class: "col-md-6 mb-20" }
const _hoisted_15 = { class: "col-md-6 mb-20" }
const _hoisted_16 = { class: "col-md-6 mb-20" }
const _hoisted_17 = { class: "col-md-6 mb-20" }
const _hoisted_18 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = ["required"]
const _hoisted_21 = { class: "col-md-12 mb-20" }
const _hoisted_22 = { class: "col-md-12 mb-20" }
const _hoisted_23 = { class: "col-md-12 mb-20" }
const _hoisted_24 = { class: "col-md-6 mb-20" }
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "col-md-6 mb-20" }
const _hoisted_27 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_28 = { class: "col-md-6 mb-20" }
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "col-md-6 mb-20" }
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "col-md-4 mb-20" }
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "col-md-4 mb-20" }
const _hoisted_35 = { class: "col-md-4 mb-20" }
const _hoisted_36 = { class: "col-md-4 mb-20" }
const _hoisted_37 = { class: "col-md-12 mb-20" }
const _hoisted_38 = { class: "d-flex align-items-center gap-3 mt-2" }
const _hoisted_39 = ["id", "value"]
const _hoisted_40 = ["for"]
const _hoisted_41 = { class: "col-md-12 d-flex align-items-center justify-content-between mt-20" }
const _hoisted_42 = { class: "d-flex flex-wrap align-items-center gap-2" }
const _hoisted_43 = {
  type: "submit",
  class: "btn btn-success px-4 py-2"
}
const _hoisted_44 = {
  key: 0,
  class: "spinner-border spinner-border-sm ms-2"
}
const _hoisted_45 = {
  class: "tab-pane fade",
  id: "driver-fees-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_46 = { class: "col-12 col-md-6" }
const _hoisted_47 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_48 = ["onUpdate:modelValue"]
const _hoisted_49 = { class: "col-12 col-md-6" }
const _hoisted_50 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_51 = { "label-for": "refused_fees" }
const _hoisted_52 = ["onUpdate:modelValue"]
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-md-12" }
const _hoisted_55 = {
  key: 1,
  class: "row"
}
const _hoisted_56 = { class: "col-md-12 d-flex align-items-center" }
const _hoisted_57 = ["disabled"]
const _hoisted_58 = {
  key: 0,
  class: "spinner-border",
  role: "status"
}
const _hoisted_59 = { class: "col-md-12 d-flex align-items-center" }
const _hoisted_60 = { class: "align-middle ml-50" }
const _hoisted_61 = {
  key: 0,
  class: "tab-pane fade",
  id: "permission-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_62 = {
  key: 0,
  class: "pm-savebar",
  role: "status"
}
const _hoisted_63 = { class: "pm-savebar-text" }
const _hoisted_64 = { class: "pm-savebar-actions" }
const _hoisted_65 = ["disabled"]
const _hoisted_66 = ["disabled"]
const _hoisted_67 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_DriverStatusApiAccess = _resolveComponent("DriverStatusApiAccess")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_center = _resolveComponent("center")!
  const _component_UserPermissions = _resolveComponent("UserPermissions")!
  const _component_DeliveryProviderFormModal = _resolveComponent("DeliveryProviderFormModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _cache[30] || (_cache[30] = _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100 active",
            id: "edit-user-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#edit-user-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "edit-user-tab-pane",
            "aria-selected": "true"
          }, " Informations de l'utilisateur ")
        ], -1)),
        _cache[31] || (_cache[31] = _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100",
            id: "driver-fees-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#driver-fees-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "driver-fees-tab-pane",
            "aria-selected": "false"
          }, " Frais de livreur ")
        ], -1)),
        (_ctx.auth.can('PERMISSION_USER'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_4, _cache[29] || (_cache[29] = [
              _createElementVNode("button", {
                class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100",
                id: "permission-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#permission-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "permission-tab-pane",
                "aria-selected": "false"
              }, " Permissions ", -1)
            ])))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("form", {
            onSubmit: _cache[23] || (_cache[23] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[32] || (_cache[32] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Photo de profil ", -1)),
                _createElementVNode("div", _hoisted_9, [
                  (_ctx.imagepreview)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.imagepreview,
                        class: "rounded-circle me-15",
                        style: {"width":"90px","height":"90px","object-fit":"cover"}
                      }, null, 8, _hoisted_10))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: require('@/assets/images/NoImage.png'),
                        class: "rounded-circle me-15",
                        style: {"width":"90px","height":"90px","object-fit":"cover"}
                      }, null, 8, _hoisted_11)),
                  _createElementVNode("div", null, [
                    _createElementVNode("input", {
                      ref: "updateImgInput",
                      type: "file",
                      accept: "image/*",
                      class: "d-none",
                      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logoSelected && _ctx.logoSelected(...args)))
                    }, null, 544),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary me-2",
                      onClick: _cache[1] || (_cache[1] = () => _ctx.updateImgInput?.click())
                    }, " Choisir la photo "),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-secondary",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelImage && _ctx.cancelImage(...args)))
                    }, " Annuler ")
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[33] || (_cache[33] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nom complet *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userData.name) = $event)),
                  type: "text",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Nom complet",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.userData.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[34] || (_cache[34] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "CIN *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userData.cin) = $event)),
                  type: "text",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "CIN",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.userData.cin]
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _cache[35] || (_cache[35] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Numéro de téléphone *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userData.phone) = $event)),
                  type: "text",
                  pattern: "^(0[0-9]{9}|\\+212[0-9]{9})$",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "0XXXXXXXXX ou +212XXXXXXXXX",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.userData.phone]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[36] || (_cache[36] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Adresse électronique *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.userData.email) = $event)),
                  type: "email",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "exemple@email.com",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.userData.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[37] || (_cache[37] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Mot de passe *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.userData.password) = $event)),
                  type: "password",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Mot de passe"
                }, null, 512), [
                  [_vModelText, _ctx.userData.password]
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, [
                  _cache[38] || (_cache[38] = _createTextVNode(" Confirmation de mot de passe ", -1)),
                  (_ctx.userData.password)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, "*"))
                    : _createCommentVNode("", true)
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.userData.c_password) = $event)),
                  type: "password",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Confirmer mot de passe",
                  required: !!_ctx.userData.password
                }, null, 8, _hoisted_20), [
                  [_vModelText, _ctx.userData.c_password]
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _cache[39] || (_cache[39] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Ville utilisateur *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.userData.city_user) = $event)),
                  type: "text",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Ville utilisateur",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.userData.city_user]
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _cache[41] || (_cache[41] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Ville *", -1)),
                _createVNode(_component_v_select, {
                  class: "custom-select-height",
                  modelValue: _ctx.userData.city_id,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.userData.city_id) = $event)),
                  label: "name",
                  options: _ctx.citiesList,
                  reduce: (c) => c.id,
                  placeholder: "Rechercher une ville..."
                }, {
                  "no-options": _withCtx(() => _cache[40] || (_cache[40] = [
                    _createTextVNode("Aucune ville trouvée", -1)
                  ])),
                  _: 1
                }, 8, ["modelValue", "options", "reduce"])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _cache[42] || (_cache[42] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Adresse *", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.userData.adresse) = $event)),
                  rows: "2",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Adresse complète",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.userData.adresse]
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _cache[43] || (_cache[43] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nom du banque *", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.userData.id_bank) = $event)),
                  class: "form-select shadow-none rounded-0"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bankList, (b, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: b.id
                    }, _toDisplayString(b.name), 9, _hoisted_25))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.userData.id_bank]
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _cache[44] || (_cache[44] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Numéro du compte *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.userData.rib) = $event)),
                  type: "text",
                  inputmode: "numeric",
                  pattern: "[0-9]{24}",
                  class: _normalizeClass(["form-control shadow-none rounded-0", { 'is-invalid': _ctx.ribCorrupted }]),
                  minlength: "24",
                  maxlength: "24",
                  placeholder: "RIB (24 chiffres)",
                  onInput: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onRibInput && _ctx.onRibInput(...args)))
                }, null, 34), [
                  [_vModelText, _ctx.userData.rib]
                ]),
                (_ctx.ribCorrupted)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, " RIB enregistré invalide (" + _toDisplayString(_ctx.ribCorrupted) + "). Veuillez ressaisir les 24 chiffres. ", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _cache[45] || (_cache[45] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Agence *", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.userData.agency) = $event)),
                  class: "form-select shadow-none rounded-0",
                  required: ""
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agencyList, (a, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: a.id
                    }, _toDisplayString(a.name), 9, _hoisted_29))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.userData.agency]
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _cache[46] || (_cache[46] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Fonction *", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.userData.role_id) = $event)),
                  class: "form-select shadow-none rounded-0",
                  required: ""
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.functionsList, (f, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: f.id
                    }, _toDisplayString(f.name), 9, _hoisted_31))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.userData.role_id]
                ])
              ]),
              (_ctx.userData?.role_id === 4)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_32, [
                      _cache[47] || (_cache[47] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Zone *", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.userData.zone_liv_id) = $event)),
                        class: "form-select shadow-none rounded-0"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zoneList, (z, i) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: i,
                            value: z.id
                          }, _toDisplayString(z.name), 9, _hoisted_33))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.userData.zone_liv_id]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _cache[48] || (_cache[48] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Frais de livraison *", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.userData.livred_fees) = $event)),
                        type: "text",
                        class: "form-control shadow-none rounded-0",
                        placeholder: "Frais de livraison"
                      }, null, 512), [
                        [_vModelText, _ctx.userData.livred_fees]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _cache[49] || (_cache[49] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Frais de refus *", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.userData.refused_fees) = $event)),
                        type: "text",
                        class: "form-control shadow-none rounded-0",
                        placeholder: "Frais de refus"
                      }, null, 512), [
                        [_vModelText, _ctx.userData.refused_fees]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _cache[50] || (_cache[50] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Frais de remboursement", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.userData.refund_fees) = $event)),
                        type: "number",
                        min: "0",
                        step: "0.01",
                        class: "form-control shadow-none rounded-0",
                        placeholder: "Aucun"
                      }, null, 512), [
                        [_vModelText, _ctx.userData.refund_fees]
                      ]),
                      _cache[51] || (_cache[51] = _createElementVNode("small", { class: "text-muted" }, "Gagné par remboursement remis, ajouté à la déduction du bon. Vide = aucun.", -1))
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _cache[52] || (_cache[52] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Autoriser le changement de statut des colis via API ", -1)),
                      _createElementVNode("div", _hoisted_38, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList([{ label: 'Oui', value: '1' }, { label: 'Non', value: '0' }], (opt) => {
                          return _createElementVNode("div", {
                            class: "form-check form-check-inline",
                            key: opt.value
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "radio",
                              id: `can_change_statut_${opt.value}`,
                              value: opt.value,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.userData.can_change_statut) = $event))
                            }, null, 8, _hoisted_39), [
                              [_vModelRadio, _ctx.userData.can_change_statut]
                            ]),
                            _createElementVNode("label", {
                              class: _normalizeClass(["form-check-label fw-medium", opt.value === '1' ? 'text-success' : 'text-danger']),
                              for: `can_change_statut_${opt.value}`
                            }, _toDisplayString(opt.label), 11, _hoisted_40)
                          ])
                        }), 64))
                      ]),
                      _createVNode(_component_DriverStatusApiAccess, {
                        "user-id": _ctx.userId,
                        "refresh-key": _ctx.apiAccessKey
                      }, null, 8, ["user-id", "refresh-key"])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("button", _hoisted_43, [
                    _cache[53] || (_cache[53] = _createTextVNode(" Enregistrer ", -1)),
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_44))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.userData?.role_id === 4)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-outline-primary px-4 py-2",
                        onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.openDriverProvider && _ctx.openDriverProvider(...args)))
                      }, [
                        _cache[54] || (_cache[54] = _createElementVNode("i", {
                          class: "ph ph-plugs-connected me-1",
                          "aria-hidden": "true"
                        }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.driverProviderId ? "Configuration prestataire" : "Lier à un prestataire"), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_router_link, {
                  to: "/users-list",
                  class: "btn btn-link text-danger"
                }, {
                  default: _withCtx(() => _cache[55] || (_cache[55] = [
                    _createTextVNode(" Annuler ", -1)
                  ])),
                  _: 1,
                  __: [55]
                })
              ])
            ])
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_45, [
          (_ctx.citiesDriver.length != 0)
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                onSubmit: _cache[25] || (_cache[25] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.citiesDriver, (citie) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "row",
                    key: citie.id
                  }, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("label", null, _toDisplayString("Frais de livraison ( " + citie.name + ")"), 1),
                        _withDirectives(_createElementVNode("input", {
                          class: "form-control",
                          type: "number",
                          min: "0",
                          "onUpdate:modelValue": ($event: any) => ((citie.delivered_fees) = $event)
                        }, null, 8, _hoisted_48), [
                          [_vModelText, citie.delivered_fees]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("label", _hoisted_51, _toDisplayString("Frais de refus ( " + citie.name + ")"), 1),
                        _withDirectives(_createElementVNode("input", {
                          class: "form-control",
                          type: "number",
                          min: "0",
                          "onUpdate:modelValue": ($event: any) => ((citie.refused_fees) = $event)
                        }, null, 8, _hoisted_52), [
                          [_vModelText, citie.refused_fees]
                        ])
                      ])
                    ])
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    (_ctx.auth.can('EDIT_USER'))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-primary px-4 py-2",
                          onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.editFeesDriver && _ctx.editFeesDriver(...args)))
                        }, " Enregistrer "))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 32))
            : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  (_ctx.auth.can('EDIT_USER'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        disabled: _ctx.loadFees,
                        class: "btn btn-primary px-4 py-2",
                        type: "button",
                        onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.handelAffectFees && _ctx.handelAffectFees(...args)))
                      }, [
                        (_ctx.loadFees)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_58, _cache[56] || (_cache[56] = [
                              _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                            ])))
                          : _createCommentVNode("", true),
                        _cache[57] || (_cache[57] = _createTextVNode(" Réaffecter les frais de livraison pour ce livreur ", -1))
                      ], 8, _hoisted_57))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("span", _hoisted_60, [
                    _createVNode(_component_center, null, {
                      default: _withCtx(() => _cache[58] || (_cache[58] = [
                        _createTextVNode("Aucune donnée trouvée", -1)
                      ])),
                      _: 1,
                      __: [58]
                    })
                  ])
                ])
              ]))
        ]),
        (_ctx.auth.can('PERMISSION_USER'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
              _createVNode(_component_UserPermissions, {
                groups: _ctx.permissionsData,
                saved: _ctx.savedPerms,
                collapsible: false,
                "show-pending": false
              }, null, 8, ["groups", "saved"]),
              _createVNode(_Transition, { name: "pm-bar" }, {
                default: _withCtx(() => [
                  (_ctx.permChanges > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                        _createElementVNode("span", _hoisted_63, [
                          _cache[59] || (_cache[59] = _createElementVNode("i", {
                            class: "ph ph-warning",
                            "aria-hidden": "true"
                          }, null, -1)),
                          _createElementVNode("b", null, _toDisplayString(_ctx.permChanges), 1),
                          _createTextVNode(" modification" + _toDisplayString(_ctx.permChanges > 1 ? "s" : "") + " non enregistrée" + _toDisplayString(_ctx.permChanges > 1 ? "s" : ""), 1)
                        ]),
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-light",
                            disabled: _ctx.load,
                            onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.getPerms && _ctx.getPerms(...args)))
                          }, " Annuler ", 8, _hoisted_65),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-primary",
                            disabled: _ctx.load,
                            onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.AddPerms && _ctx.AddPerms(...args)))
                          }, [
                            (_ctx.load)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_67))
                              : _createCommentVNode("", true),
                            _cache[60] || (_cache[60] = _createTextVNode(" Enregistrer ", -1))
                          ], 8, _hoisted_66)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_DeliveryProviderFormModal, {
      ref: "providerModal",
      onSaved: _ctx.onProviderSaved
    }, null, 8, ["onSaved"])
  ]))
}